module.exports = "pegasus_template/assets/themecapture1/creative/100.png";